<template>
  <div class="cover-left-detached media-small">
    <div class="layer media-container">
      <slot name="media"></slot>
    </div>

    <div class="layer content-container">
      <div class="content-box">
        <slot name="header"></slot>
        <slot name="jobCounter"></slot>
        <slot name="ctaButton"></slot>
        <slot name="search"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoverLeftDetached",
};
</script>

<style lang="scss" scoped>
@import "../scss/shared";
@import "../scss/media-small";

.media-container {
  padding-left: 64px;
}
</style>
